import React from 'react'

const OtherSettingsPage = () => {
  return (
    <div>
      <p>cghchv</p>
    </div>
  )
}

export default OtherSettingsPage
